<template>
  <div>
    <div class="main_bottom" v-if="publicClass">
      <div class="mani_list">
        <ul class="clearfix">
          <li v-for="(items, index) in publicClass" :key="index">
            <router-link
              :to="{
                path: '/publicClass_details',
                query: { KId: items.JumpUrl, nav: 3, info: 'share' }
              }"
            >
              <dl>
                <dt><img :src="publicClass_imgs[index][0]" width="100%" /></dt>
                <dd>
                  <h2>{{ items.Title }}</h2>
                  <p class="p1">
                    #{{ publicClass_p[index].student.replace(/,/g, "#") }}
                  </p>
                  <p class="p2">{{ publicClass_p[index].time }}</p>
                  <div class="p3">
                    <em
                      ><img :src="publicClass_imgs[index][1]" width="100%"
                    /></em>
                    <span>{{ publicClass_p[index].teacher }}</span>
                    <strong>{{ publicClass_p[index].price }}</strong>
                  </div>
                </dd>
              </dl>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      publicClass: [],
      publicClass_imgs: [],
      publicClass_p: []
    };
  },
  mounted: function() {
    let that = this;
    this.$http
      .get("https://schoolapi.eiceducation.com.cn/api/PageInfo?pageTypeId=6")
      .then(function(response) {
        that.publicClass = response.data.results;
        // console.log(response.data.results)
        var bobao = [];
        var imgs = [];
        for (var i = 0; i < response.data.results.length; i++) {
          var bobao_xq = JSON.parse(response.data.results[i].MoreFieldsValue);
          var imgs_xq = response.data.results[i].ImageArrays.split(",");
          bobao.push(bobao_xq);
          imgs.push(imgs_xq);
        }
        that.publicClass_p = bobao;
        that.publicClass_imgs = imgs;
        // // console.log(bobao)
        // // console.log(imgs)
      })
      .catch(function() {
        // console.log('错误');
      });
  }
};
</script>

<style scoped>
.main_bottom {
  width: 1180px;
  margin: 0 auto;
  padding-top: 66px;
}

.main_bottom .title {
  height: 77px;
  text-align: center;
}

.main_bottom .title span {
  display: inline-block;
  font-size: 28px;
  color: #333333;
  line-height: 56px;
  font-weight: 500;
  padding-right: 12px;
  padding-left: 13px;
  background: url(../../assets/publicClass/main_bottom2.png) right 34px
    no-repeat;
  position: relative;
}

.main_bottom .title span em {
  position: absolute;
  left: 0;
  top: 0;
  width: 40px;
  height: 40px;
  background: url(../../assets/publicClass/main_bottom1.png) left top no-repeat;
}

.main_bottom .title span strong {
  position: relative;
  font-weight: normal;
}
.mani_list ul li {
  width: 280px;
  height: 346px;
  float: left;
  background: #ffffff;
  box-shadow: 0px 0px 10px 6px rgba(245, 246, 246, 0.2);
  border-radius: 8px;
  overflow: hidden;
  margin-right: 20px;
  margin-bottom: 20px;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
  position: relative;
}

.mani_list ul li:hover {
  box-shadow: 0px 0px 10px 6px #f5f6f6;
  transform: translateY(-8px);
}

.mani_list ul li:nth-child(4n) {
  margin-right: 0;
}

.mani_list ul li dt {
  width: 280px;
  height: 174px;
  overflow: hidden;
}

.mani_list ul li dd {
  padding: 0 16px;
  padding-top: 20px;
  text-align: left;
}

.mani_list ul li dd h2 {
  font-size: 16px;
  color: #333;
  line-height: 16px;
  margin-bottom: 8px;
  font-weight: normal;
}

.mani_list ul li dd .p1 {
  width: 100%;
  font-size: 12px;
  color: #4e5cf6;
  line-height: 12px;
  margin-bottom: 8px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mani_list ul li dd .p2 {
  font-size: 12px;
  color: #666;
  line-height: 12px;
  margin-bottom: 24px;
}

.mani_list ul li dd .p3 {
  height: 38px;
}

.mani_list ul li dd .p3 em {
  display: block;
  width: 34px;
  height: 34px;
  border: 2px #f5f6f6 solid;
  border-radius: 38px;
  float: left;
  overflow: hidden;
  margin-right: 8px;
}

.mani_list ul li dd .p3 span {
  font-size: 14px;
  color: #333;
  line-height: 38px;
}

.mani_list ul li dd .p3 strong {
  font-size: 24px;
  float: right;
  line-height: 38px;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/page2/public/publicClass.vue